import React, { useState } from 'react';
import { useNavigate } from 'react-router-dom';
import { useAuth } from '../context/AuthContext';
// import CreateProject from './admin/CreateProject';
import CreateProject from './admin/projects/CreateProject';
import Reports from './admin/reports/Reports'
import UploadTasks from './admin/tasks/UploadTasks';
import Employees from './admin/employees/Employees';

const TABS = [
 
  { key: 'project', label: '📁 Projects' },
   { key: 'reports', label: '📊 Reports' },
  { key: 'task', label: '✅ Tasks' },
  { key: 'employee', label: '👤 Employees' },
];

const AdminDashboard = () => {
  const [tab, setTab] = useState('project');
  const { user, logout } = useAuth();
  const navigate = useNavigate();

  if (user?.role !== 'ADMIN') {
    return <div className="auth-page"><div className="auth-card"><h2>Access Denied ❌</h2></div></div>;
  }

  const handleLogout = () => {
    logout();
    navigate('/login');
  };

  return (
    <div className="admin-layout">
      <div className="admin-sidebar">
        <div className="admin-logo"> Admin Panel</div>
        <nav className="admin-nav">
          {TABS.map(t => (
            <button
              key={t.key}
              className={`admin-nav-item${tab === t.key ? ' active' : ''}`}
              onClick={() => setTab(t.key)}
            >
              {t.label}
            </button>
          ))}
        </nav>
        <div className="admin-sidebar-footer">
          <span className="admin-user-name">👤 {user?.name}</span>
          <button className="btn-logout" onClick={handleLogout}>Logout</button>
        </div>
      </div>

      <div className="admin-main">
        <div className="admin-topbar">
          <h2 className="admin-page-title">
            {TABS.find(t => t.key === tab)?.label}
          </h2>
        </div>
        <div className="admin-content">
           {tab === 'reports' && <Reports />}
          {tab === 'project' && <CreateProject />}
          {tab === 'task' && <UploadTasks />}
           {tab === 'employee' && <Employees />}
        </div>
      </div>
    </div>
  );
};

export default AdminDashboard;
